import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./_store";
import Buefy from "buefy";
// import "buefy/dist/buefy.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./registerServiceWorker";

Vue.use(Buefy, {
  defaultIconPack: "fas"
});

Vue.config.productionTip = false;

import sappLoading from "./components/app-loading";
Vue.component("sapp-loading", sappLoading);

import sappBack from "./components/app-back";
Vue.component("sapp-back", sappBack);

Vue.filter("formatMoney", function(n, c, d, t) {
  c = isNaN((c = Math.abs(c))) ? 2 : c;
  d = d == undefined ? "." : d;
  t = t == undefined ? "," : t;
  var s = n < 0 ? "-" : "";
  var i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))));
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#sapp");
